import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("App error caught:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          background: "linear-gradient(135deg, #0D1B4B 0%, #0E6B5E 100%)",
          color: "white", padding: 24, textAlign: "center",
        }}>
          <div style={{ maxWidth: 400 }}>
            <div style={{ fontSize: 60 }}>🚀</div>
            <h2 style={{ marginBottom: 12 }}>Что-то пошло не так</h2>
            <p style={{ opacity: 0.8, marginBottom: 24 }}>
              Не волнуйся — приложение в порядке. Просто перезагрузи страницу.
            </p>
            <button
              onClick={() => { localStorage.removeItem("tgc_jwt"); window.location.reload(); }}
              style={{
                background: "#E8A020", color: "#0D1B4B", border: "none",
                padding: "14px 28px", borderRadius: 12, fontSize: 16, fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
